/*!
 *
 * components.js
 *
 */


'use strict';

// plugins
require('jquery');
require('jquery.easing');
require('jquery-mobile-events');
require('slick-carousel');

// module
require('origin');
require('tab-navigator');
require('fade-contents');

var linker = require('linker');
var slideScroll = require('slide-scroll');
var topVideo = require('top-video');
var phoneCheck = require('phone-check');
var particleground = require('jquery.particleground.min');
var menu = require('menu');
var mainvis = require('mainvis');
var current = require('current');

(function($) {
	$(function(){
		phoneCheck();
		linker.init({
			extendLink: '.common_related_list_box,.product_case_list_box,.common_box_link,.common_blog_01,.top_products_box, .common_linker_01'
		});
		current();

		// Smooth scroll
		slideScroll({
			speed: 700,
			easing: 'swing',
			not: '.not-scroll, .tab a, .tab_head a, .measurement_tab a, .measurement_tab_head a, #menu_btn a'
		});

		// Menu
		menu.init();

		// top Video
		topVideo.init();

		// Tab
		$('.tab').tabNavigator();
		$('.measurement_tab').tabNavigator({
			head: '.measurement_tab_head',
			offsetClass: '.measurement_tab_wrapper_01'
		});

		// fade contents
		$('#products .common_header_primary, #products .top_products_box_wrapper, #news .top_contents_inner, #blog .top_contents_inner, #company_inner, #inquiry .top_contents_inner').fadeContents();

		// Particle
		$(window).on('load', function() {

			$(".top_contents, .common_inquiry_single_01, .common_inquiry_single_02, .common_inquiry").particleground({
		    dotColor: '#eeeeee',
		    lineColor: '#eeeeee',
				parallax: false,
		  });
		});

		$('.common_related_list').slick({
			dots: true,
			infinite: false,
			speed: 300,
			centerPadding: '25px',
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},{
				breakpoint: 481,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		});
		$('.common_slick_mv').slick({
			dots: true,
			centerPadding: 0,
			infinite: true,
			speed: 300,
			autoplay: true,
  		autoplaySpeed: 6000
		});

	});
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./dev/dcms_media/js/components/app.js
// module id = 0
// module chunks = 0